module.exports = __webpack_public_path__ + "static/media/portrait3.f786c3df.png";